.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  padding: 24px;
  gap: 16px;
  text-align: center;
  color: var(--color-text-primary);
}

.content {
  max-width: 370px;

  :where(svg, img) {
    width: 200px;
    aspect-ratio: 1;
    object-fit: contain;
    max-width: 100%;
    margin-bottom: 16px;
  }

  p {
    margin-top: 8px;
    font-size: 15px;
    line-height: 1.4;
    color: var(--color-text-secondary);
    text-wrap: pretty;
  }

  a {
    color: var(--color-text-status-links);
  }
}

.heading {
  font-size: 17px;
  font-weight: 500;
  text-wrap: balance;
  line-height: 1.2;
}

.errorImage {
  width: 280px;
  margin: -10% 0;
}

[data-color-scheme='dark'] .defaultImage {
  --color-skin-1: #3a3a50;
  --color-skin-2: #67678e;
  --color-skin-3: #44445f;
  --color-outline: #21212c;
  --color-shadow: #181820;
  --color-highlight: #b2b1c8;
}
